import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UniteShippingCostPayerPipe } from './pipes/unite-shipping-cost-payer.pipe';
import { UniteStateOfProductPipe } from './pipes/unite-state-of-product.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [UniteShippingCostPayerPipe, UniteStateOfProductPipe],
    exports: [UniteShippingCostPayerPipe, UniteStateOfProductPipe],
})
export class SharedUnitePipesModule {}
